import { styled } from "@mui/material/styles";

export const Root = styled("div", { label: "AppLayout-root" })(
  ({ theme: Theme }) => ({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    height: "100%",
    width: "100%",
    minWidth: 1024,

    "@media print": {
      height: 'auto',
      display: 'block',
    },
  })
);
export const Content = styled("div", { label: "AppLayout-content" })(
  ({ theme: Theme }) => ({
    display: "flex",
    flexDirection: "row",
    flex: "1 1 auto",
    height: "100%",
    width: "100%",
    overflow: "auto",

    "@media print": {
      height: 'auto',
    },
  })
);
